import React, { useState, useEffect } from 'react';
import '../styles/NewsPage.css';

function NewsPage() {
  const [mataiNews, setMataiNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      const mockMataiNews = [
        {
          id: 1,
          title: "Congratulations to the MATAI Team for Unlocking Stage 1b!",
          content: "We are proud to share that the MATAI team has successfully completed Stage 1a of the AI for Materials Discovery project—marking a major milestone in our mission to accelerate materials discovery through AI.",
          date: "May 2025",
          category: "Achievement"
        },
        {
          id: 2,
          title: "Dr. Bijun Tang Named AI2050 Early Career Fellow",
          content: "Congratulations to our PI, Dr. Bijun Tang, for being selected as one of the AI2050 Early Career Fellows by Schmidt Sciences. She is the only Fellow from an Asian institution in the 2024 cohort and the first recipient from NTU to receive this prestigious fellowship. As one of 25 global scholars advancing AI for the benefit of humanity, Dr. Tang joins an exceptional group of researchers awarded up to US$12 million to pursue their bold visions for a better future by 2050.",
          date: "Dec 2024",
          category: "Fellowship"
        },
        {
          id: 3,
          title: "Three MATAI PIs Recognized Among World's Top 2% Scientists",
          content: "Congratulations to our PIs, Prof. Bo An, Prof. Cuntai Guan, and Prof. Zheng Liu for being named among the World's Top 2% Scientists in 2024, as ranked by Stanford University using Elsevier's Scopus data. This recognition highlights their scientific excellence and career-long impact.",
          date: "Sep 2024",
          category: "Recognition"
        },
        {
          id: 4,
          title: "Prof. Bo An Invited as IJCAI 2024 Keynote Speaker",
          content: "Our warmest congratulations to our PI, Prof. Bo An, for being invited to deliver a keynote speech at the International Joint Conference on Artificial Intelligence (IJCAI) 2024, a premier forum for AI researchers worldwide.",
          date: "Aug 2024",
          category: "Speaking"
        },
        {
          id: 5,
          title: "Dr. Xinrun Wang Joins SMU as Assistant Professor",
          content: "Congratulations to our Technical Lead, Dr. Xinrun Wang, on his new appointment as Assistant Professor at the School of Computing and Information Systems, Singapore Management University (SMU).",
          date: "Jul 2024",
          category: "Career"
        },
        {
          id: 6,
          title: "Dr. Yuhao Lu Publishes in Nature Communications",
          content: "Kudos to our Technical Lead, Dr. Yuhao Lu for publishing her work on AI for Materials Science in Nature Communications, now a highly cited paper: 10.1038/s41467-024-49172-6. Her work advances the field with novel approaches to intelligent synthesis optimization.",
          date: "Jun 2024",
          category: "Publication"
        },
        {
          id: 7,
          title: "Prof. Cuntai Guan Wins Nanyang Research Award",
          content: "Congratulations to our PI, Prof. Cuntai Guan, for receiving the Nanyang Research Award (University), the highest honor for NTU researchers. This award recognizes his groundbreaking achievements and global leadership in AI and brain-computer interface research.",
          date: "Nov 2023",
          category: "Award"
        },
        {
          id: 8,
          title: "Prof. Zheng Liu Awarded APEC ASPIRE Prize",
          content: "We are thrilled to announce that our PI, Prof. Zheng Liu, has won the 2023 APEC Science Prize for Innovation, Research and Education (ASPIRE). Chosen from 16 finalists, Prof. Liu was honored for his inclusive and impactful scientific research, especially under the ASPIRE theme: \"Inclusive Science, Technology, and Innovation for a Resilient and Sustainable Environment.\"",
          date: "Aug 2023",
          category: "Award"
        }
      ];
      
      setMataiNews(mockMataiNews);
      setIsLoading(false);
    }, 500);
  }, []);

  const getCategoryColor = (category) => {
    const colors = {
      'Achievement': '#10b981',
      'Fellowship': '#8b5cf6',
      'Recognition': '#f59e0b',
      'Speaking': '#3b82f6',
      'Career': '#06b6d4',
      'Publication': '#ef4444',
      'Award': '#f97316'
    };
    return colors[category] || '#64748b';
  };

  return (
    <div className="news-page">
      <div className="news-container">
        <div className="news-header">
          <h2>News & Highlights</h2>
          <p className="news-subtitle">Stay updated with the latest achievements, milestones, and developments from the MATAI team</p>
        </div>

        {isLoading ? (
          <div className="loading-section">
            <div className="loading-spinner-large"></div>
            <p>Loading latest news...</p>
          </div>
        ) : (
          <div className="news-timeline">
            {mataiNews.map(item => (
              <div className="news-item" key={item.id}>
                <div className="news-date-badge">
                  <span className="news-date">{item.date}</span>
                </div>
                <div className="news-content">
                  <div className="news-header-row">
                    <h3 className="news-title">{item.title}</h3>
                    <div className="news-category" style={{ backgroundColor: getCategoryColor(item.category) }}>
                      {item.category}
                    </div>
                  </div>
                  <p className="news-description">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default NewsPage; 